import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { getVrecordUsages } from '@/api/dashboard/playturbo.js';
import { testList } from '@/views/producer/common-template/selling-strategy.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';

var dayTime = 1000 * 60 * 60 * 24;

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')], // 时间
  adv_ids: [],
  adv_id: '',
  adv_search_type: 'adv_name',
  keyword: '',
  is_test: '',
  export: 0
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前180天的日期
              disabledDate: function disabledDate(time) {
                var curDate = new Date().getTime();
                var threeMonths = curDate - 180 * 24 * 3600 * 1000;
                return time.getTime() > Date.now() || time.getTime() < threeMonths;
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
              /* eslint-enable no-mixed-operators */
            }
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        is_test: {
          prop: 'is_test',
          type: 'select',
          params: {
            placeholder: '是否测试账号',
            clearable: true,
            options: testList
          }
        }
      };
      if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '日期',
        prop: 'date'
      }, {
        label: '广告主ID',
        prop: 'adv_id',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return row.adv_id || '-';
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.adv_name || '-';
          }
        }
      }, {
        label: '是否测试账号',
        prop: 'is_test',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            var temp = testList.find(function (s) {
              return s.value === row.is_test;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '创建/使用录屏项目数',
        prop: 'project_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '创建/使用录屏版本数',
        prop: 'gameplay_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '导出视频数',
        prop: 'video_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '视频总长度(s)',
        prop: 'video_duration',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }];

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    },
    'query.adv_search_type': function queryAdv_search_type(val) {
      if (val === 'adv_name') {
        this.query.adv_id = '';
      } else {
        this.query.adv_ids = [];
      }
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.query, {
        adv_ids: this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id],
        export: 1
      });
      if (this.query.adv_search_type === 'adv_name' && !this.query.adv_ids) {
        delete params.adv_id;
      } else if (this.query.adv_search_type === 'adv_id' && !this.query.adv_id) {
        delete params.adv_ids;
      }
      downloadWithNewWindow(v2Host + '/dashboard/vrecord/usage-report?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    handleSortChange: function handleSortChange(_ref4) {
      var column = _ref4.column,
          prop = _ref4.prop,
          order = _ref4.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var innerParams, res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                innerParams = _.omit(_.cloneDeep(params || _this.query), ['adv_search_type', 'adv_id']);
                _context.next = 5;
                return getVrecordUsages(_extends({}, innerParams, {
                  adv_ids: _this.query.adv_search_type === 'adv_name' ? _this.query.adv_ids : [_this.query.adv_id]
                }));

              case 5:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.list') || []);

                console.log(list);
                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 14]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};